<template>
  <v-container fluid>
    <v-card class="pa-6 mx-auto" elevation="4" max-width="760" rounded="xl">
      <h2 class="text-h5 mb-2">
        Planificar y descargar la planificación
      </h2>

      <p class="text-body-2 mb-6">
        Selecciona cliente, delegación y semanas para descargar el XLS.
      </p>

      <v-select
        v-model="form.client_tipo"
        :items="tipusClient"
        label="Cliente"
        item-title="title"
        item-value="value"
        variant="outlined"
        density="comfortable"
        :disabled="loading"
        class="mb-4"
      />

      <v-select
        v-model="form.delegacio_id"
        :items="delegacions"
        label="Delegación"
        item-title="title"
        item-value="value"
        variant="outlined"
        density="comfortable"
        :disabled="loading"
        class="mb-4"
      />

      <v-row>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="form.any"
            label="Año"
            type="number"
            variant="outlined"
            density="comfortable"
            :disabled="loading"
            min="2020"
            max="2100"
          />
        </v-col>

        <v-col cols="12" md="4">
          <v-select
            v-model="form.setmana_ini"
            :items="setmanes"
            label="Semana inicial"
            item-title="title"
            item-value="value"
            variant="outlined"
            density="comfortable"
            :disabled="loading"
          />
        </v-col>

        <v-col cols="12" md="4">
          <v-select
            v-model="form.setmana_fi"
            :items="setmanes"
            label="Semana final"
            item-title="title"
            item-value="value"
            variant="outlined"
            density="comfortable"
            :disabled="loading"
          />
        </v-col>
      </v-row>

      <v-alert
        v-if="error"
        type="error"
        variant="tonal"
        class="mb-4"
      >
        {{ error }}
      </v-alert>

      <v-btn
        color="primary"
        block
        size="large"
        :loading="loading"
        :disabled="!potDescarregar"
        @click="descarregarXls"
      >
        Descargar XLS
      </v-btn>

      <v-divider class="my-6" />

      <div class="d-flex justify-end">
        <v-btn
          color="success"
          variant="tonal"
          size="small"
          prepend-icon="mdi-folder-zip"
          @click="descarregarZipEquips"
        >
          Descargar CSV de equipos
        </v-btn>
      </div>
    </v-card>
    
  </v-container>
</template>

<script setup>
import { computed, reactive, ref } from 'vue'
import axios from 'axios'

const loading = ref(false)
const error = ref('')

const currentYear = new Date().getFullYear()

const form = reactive({
  delegacio_id: 453,
  client_tipo: 'todos',
  any: currentYear,
  setmana_ini: '',
  setmana_fi: '',
})

const tipusClient = [
  { title: 'Todos los clientes', value: 'todos' },
  { title: 'Mondo', value: 'mondo' },
]

const delegacions = [
  { title: 'Barcelona', value: 453 },
  { title: 'Madrid', value: 502 },
  { title: 'Girona', value: 7042 },
  { title: 'Tarragona', value: 2016 },
  { title: 'Toledo', value: 7153 },
  { title: 'Guadalajara', value: 9784 },
  { title: 'Traycco Caprabo', value: 8774 },
  { title: 'Traycco Alcampo', value: 9126 },
]

const setmanes = Array.from({ length: 52 }, (_, index) => {
  const setmana = index + 1

  return {
    title: `Semana ${setmana}`,
    value: setmana,
  }
})

const potDescarregar = computed(() => {
  return form.delegacio_id
    && form.client_tipo
    && form.any
    && form.setmana_ini
    && form.setmana_fi
    && Number(form.setmana_fi) >= Number(form.setmana_ini)
})

const descarregarXls = async () => {
  if (!potDescarregar.value) {
    error.value = 'Selecciona delegación, año, semana inicial y semana final.'
    return
  }

  loading.value = true
  error.value = ''

  try {
    const response = await axios.get('/api/admin/planimetria/descarregar-xls', {
      params: {
        delegacio_id: form.delegacio_id,
        client_tipo: form.client_tipo,
        any: form.any,
        setmana_ini: form.setmana_ini,
        setmana_fi: form.setmana_fi,
      },
      responseType: 'blob',
    })

    const blob = new Blob([response.data], {
      type: 'text/csv;charset=utf-8',
    })

    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')

    link.href = url
    link.download = `planificador_${form.client_tipo}_${form.delegacio_id}_${form.any}_S${form.setmana_ini}_S${form.setmana_fi}.csv`

    document.body.appendChild(link)
    link.click()

    link.remove()
    window.URL.revokeObjectURL(url)
  } catch (err) {
    console.error(err)

    error.value = err?.response?.data?.message
      || 'No se ha podido descargar el XLS.'
  } finally {
    loading.value = false
  }
}

const descarregarZipEquips = () => {
  const link = document.createElement('a')

  link.href = '/storage/planificacion/equipos_planificacion.zip'
  link.download = 'equipos_planificacion.zip'

  document.body.appendChild(link)
  link.click()

  link.remove()
}

</script>